const Loading = () => {
    return (
        <div class="animate-spin my-auto" style={{
            border:'12px solid rgba(243, 243, 243, 0.4)',
            borderRadius:'50%',
            borderTop:'12px solid rgba(52, 152, 219, 0.8)',
            width:'80px',
            height:'80px',
            
        }}></div>
    )
}

export default Loading